/**
 * Converts any object into a clean HTML table string.
 * @param {Object} data - The dynamic data object from your form.
 * @param {string} title - Heading for the email.
 */
export const createHtmlTemplate = (data, title = "New Inquiry Data") => {
    // Generate rows dynamically based on object keys
    const rows = Object.entries(data)
        .map(([key, value]) => `
            <tr>
                <td style="padding: 12px; border: 1px solid #e2e8f0; font-weight: 600; color: #4a5568; background: #f8fafc; width: 35%; text-transform: capitalize;">
                    ${key.replace(/_/g, ' ')}
                </td>
                <td style="padding: 12px; border: 1px solid #e2e8f0; color: #2d3748;">
                    ${value}
                </td>
            </tr>
        `).join('');

    return `
        <div style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; max-width: 600px; margin: 20px auto; border: 1px solid #e2e8f0; border-radius: 8px; overflow: hidden;">
            <div style="background: #1a202c; color: #ffffff; padding: 20px; text-align: center;">
                <h2 style="margin: 0; font-size: 20px;">${title}</h2>
            </div>
            <div style="padding: 20px; background: #ffffff;">
                <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
                    ${rows}
                </table>
            </div>
            <div style="background: #edf2f7; padding: 15px; text-align: center; font-size: 12px; color: #718096;">
                This inquiry was sent from <strong>emailapi.smsboom.in</strong>
            </div>
        </div>
    `;
};